export const premium = [
  {
    id: 1,
    name: "Toyota Fortuner AC",
    image: "/images/gallery/premium/fortuner.jpg",

    gallery: [
      "/images/gallery/premium/fortuner.jpg",
      "/images/gallery/premium/fortuner-interior.jpg",
      "/images/gallery/premium/fortuner-back.jpg"
    ],

    body: "SUV",
    seats: "7",
    doors: "5",
    engine: "2755 cc",
    transmission: "Manual / Automatic",
    fuel: "Diesel",
    ac: "AC"
  },

  {
    id: 2,
    name: "Toyota Camry Hybrid",
    image: "/images/gallery/premium/camry.jpg",

    gallery: [
      "/images/gallery/premium/camry.jpg",
      "/images/gallery/premium/camry-interior.jpg",
      "/images/gallery/premium/camry-tyre.jpg",
  
    ],

    body: "Sedan",
    seats: "4 + 1",
    doors: "4",
    engine: "2487 cc Hybrid",
    transmission: "Automatic",
    fuel: "Petrol / Hybrid",
    ac: "AC"
  },

  {
    id: 3,
    name: "Kia Carnival Limousine",
    image: "/images/gallery/premium/carnival.jpg",

    gallery: [
      "/images/gallery/premium/carnival.jpg",
      "/images/gallery/premium/carnival-interior.jpg",
      "/images/gallery/premium/carnival-tyre.jpg",
    ],

    body: "MUV / Limousine",
    seats: "7 + 1",
    doors: "5",
    engine: "2199 cc",
    transmission: "Automatic",
    fuel: "Diesel",
    ac: "AC"
  }
];
